import { StorageTip } from './../../models/storageTip';
import { isNullOrUndefined } from 'util';
import { PageSettings } from './../../models/pageSettings';
import { Component, Input, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { DataTable } from "primeng/primeng";

@Component({
  selector: 'scs-storage-tips',
  templateUrl: './storage-tips.component.html',
  styleUrls: ['./storage-tips.component.css']
})
export class StorageTipsComponent implements OnInit {
  @Input() pageSettings: PageSettings;
  @Input() clientData;
  @Input() side: string; // 'leftColumn' or 'rightColumn'

  storageTip: any;
  selectedStorageTip: StorageTip;
  displayStorageTipDialog: boolean;
  newStorageTip: boolean;

  constructor(public afService: FirebaseService) { }

  ngOnInit() {
    // console.log(this.pageSettings.storageTips);
    if (isNullOrUndefined(this.pageSettings.storageTips)) {
      this.pageSettings.storageTips = {
        leftColumn: [],
        rightColumn: []
      };
    }
    if (isNullOrUndefined(this.pageSettings.storageTips.leftColumn)) {
      this.pageSettings.storageTips.leftColumn = [];
    }
    if (isNullOrUndefined(this.pageSettings.storageTips.rightColumn)) {
      this.pageSettings.storageTips.rightColumn = [];
    }
  }

  showStorageTipDialogToAdd() {
    this.newStorageTip = true;
    this.storageTip = new StorageTip();
    this.displayStorageTipDialog = true;
  }

  onStorageTipRowSelect(event) {
    this.newStorageTip = false;
    this.storageTip = event.data;
    this.displayStorageTipDialog = true;
  }

  saveStorageTip() {
    if (this.newStorageTip == true) {
      this.pageSettings.storageTips[this.side].push(this.storageTip);
    }
    else {
      this.pageSettings.storageTips[this.side][this.findIndex()] = this.storageTip;
    }

    this.storageTip = null;

    this.displayStorageTipDialog = false;
    this.savePageSettings();
  }

  savePageSettings() {
    for (let tmp of this.pageSettings.storageTips[this.side]) {
      delete tmp._$visited;
    }
    this.afService.savePageSettings(this.clientData, this.pageSettings).then(() => {
      if (isNullOrUndefined(this.pageSettings.storageTips.leftColumn))
        this.pageSettings.storageTips.leftColumn = [];
      if (isNullOrUndefined(this.pageSettings.storageTips.rightColumn))
        this.pageSettings.storageTips.rightColumn = [];
      this.afService.openSnackBar('Page Settings Updated Successfully');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  deleteStorageTip() {
    let index = this.findIndex();
    this.pageSettings.storageTips[this.side] = this.pageSettings.storageTips[this.side].filter((val, i) => i != index);
    this.selectedStorageTip = null;
    this.displayStorageTipDialog = false;
    this.savePageSettings();
  }

  findIndex(): number {
    return this.pageSettings.storageTips[this.side].indexOf(this.selectedStorageTip);
  }

  shouldShow() {
    return !isNullOrUndefined(this.pageSettings) && !isNullOrUndefined(this.pageSettings.storageTips);
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/storage-tips/storage-tips.component.ts